import type { MentorshipCaseStatus } from '../types'

export const MENTORSHIP_STATUS_LABELS: Record<MentorshipCaseStatus, string> = {
  draft: 'Черновик',
  pending_approval: 'На согласовании',
  active: 'Активно',
  paused: 'Приостановлено',
  final_review: 'Итоговая проверка',
  completed: 'Завершено',
  cancelled: 'Отменено',
  archived: 'В архиве',
}

export const MENTORSHIP_STATUS_COLORS: Record<MentorshipCaseStatus, string> = {
  draft: 'secondary',
  pending_approval: 'warning',
  active: 'primary',
  paused: 'warning',
  final_review: 'info',
  completed: 'success',
  cancelled: 'error',
  archived: 'secondary',
}
